import { BlockUIAction, BlockUIState } from "../@types/blockUI";
import BlockUIActionTypes from "./blockUIActionTypes";

const initialState: BlockUIState = {
  blocked: false,
  count: 0,
};

const blockUIReducer = (
  state: BlockUIState = initialState,
  action: BlockUIAction
): BlockUIState => {
  if (!state) {
    return { blocked: false, count: 0 };
  }
  switch (action.type) {
    case BlockUIActionTypes.START:
      return { blocked: true, count: state.count + 1 };
    case BlockUIActionTypes.STOP:
      const nextCount = Math.max(0, state.count - 1);
      return { blocked: nextCount > 0, count: nextCount };
  }
  return state;
};
export default blockUIReducer;
